import {
    Badge,
    Box,
    Button,
    CopyButton,
    JsonInput,
    Tooltip,
    rem,
} from '@mantine/core';
import { IconCopy, IconCopyCheck } from '@tabler/icons-react';

const CopyIdCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <CopyButton value={rowData.eventId}>
            {({ copied, copy }) => (
                <Tooltip label={'Copy ID'}>
                    <Button
                        size={'compact-xs'}
                        color={copied ? 'teal.6' : 'blue'}
                        onClick={copy}>
                        {copied ? (
                            <IconCopyCheck
                                style={{
                                    width: rem(10),
                                    height: rem(10),
                                }}
                                stroke={1.5}
                            />
                        ) : (
                            <IconCopy
                                style={{
                                    width: rem(10),
                                    height: rem(10),
                                }}
                                stroke={1.5}
                            />
                        )}
                    </Button>
                </Tooltip>
            )}
        </CopyButton>
    );
};

const CopyIdColumn = () => ({
    accessorKey: 'id',
    header: 'Copy ID',
    size: 2,
    minSize: 40,
    Cell: ({ cell }) => <CopyIdCell cell={cell} />,
});
export default CopyIdColumn;
